<template>
  <div class="mod-order-pay container clearfix">
    <div class="head clearfix">
      <!-- <span
        class="f-26 f-left"
        :hidden="hideSuccess"
      >恭喜您，订单生成成功！</span> -->
      <span class="f-22 order-num">订单号：{{orderNo}}</span>
    </div>
    <div class="detail">
      <!-- <p class="title">
        待支付金额：<em>{{orderDetail.unPayAmount}}元</em>
      </p> -->

      <!-- <p class="title">友情提示：</p>
      <p>请在支付前，确认您的订单无误后再进行操作！订单号将作为免注册购票用户后续服务的唯一认证标识，请妥善保管！您需要在<em>20分钟</em>内进行支付和后续操作。超过<em>20分钟</em>，航空公司将不保证您的订单有效。</p> -->
      <p class="tips">
        <template v-if="payLimit">
          <p class="title">友情提示：</p>
          <p>请在支付前，确认您的订单无误后再进行操作！订单号将作为免注册购票用户后续服务的唯一认证标识，请妥善保管！您需要在 <em> {{ payLimit | payLimit }} </em> 内完成订单支付，超过支付时限未支付，航空公司将不保证您的订单有效。</p>
        </template>
        <template v-else>
          <p class="title">友情提示：</p>
          <p>已超过订单支付时限，请勿再操作支付，避免预定失败产生损失。</p>
        </template>
      </p>
      <p class="title">增值订单信息：</p>
      <table>
        <tr>
          <th>序号</th>
          <th>旅客姓名</th>
          <th>行程</th>
          <th>航班日期</th>
          <th>产品类型</th>
          <th>产品名称</th>
          <th>价格</th>
          <th>数量</th>
        </tr>
        <template
          v-for="item in orderDetail.passengers"
        >
          <tr
            v-for="(product,idx) in item.details"
            :key="idx"
          >
            <td>{{idx+1}}</td>
            <td>{{product.passengerName}}</td>
            <td>{{product.depAirCn}}-{{product.arrAirCn}}</td>
            <td>{{product.flightDate}}</td>
            <td>{{product.productTypeCn}}</td>
            <td>{{product.productName}}</td>
            <td>{{product.orderAmount}}元</td>
            <td>1份</td>
          </tr>
        </template>
      </table>
    </div>
    <div class="clearfix">
      <div class="total">
        <p class="f-22"><em>订单总额：{{orderDetail.orderAmount}}元</em></p>
        <!-- <p>支付手续费发票均为国税定额手撕发票</p>
        <p>若有需求可联系祥鹏工作人员邮寄到付</p> -->
      </div>
    </div>
    <div class="head clearfix m-t-50">
      <span class="f-26">确认支付</span>
    </div>
    <div class="tab clearfix">
      <PayBox
        ref="payBox"
        @paying="payingHandler"
        @paid="payDoneHandler"
        :payExtend="{
          filter: payFilter
        }"
      />
    </div>
    <div class="foot">
      <a-button
        class="btn"
        type="primary"
        @click="toDetail"
      >查看订单</a-button>
      <a-button
        class="btn"
        type="primary"
        @click="toPay"
      >支付</a-button>
    </div>
    <a-modal
      title="系统提示"
      v-model="visible"
      :closable="false"
      class="mod-l8-alert-model"
      centered
    >
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          @click="handleError"
        >
          支付遇到问题
        </a-button>
        <a-button
          key="submit"
          type="primary"
          @click="handleOk"
        >
          已完成付款
        </a-button>
      </template>
      <h1>请您在新打开的网上银行页面上完成付款</h1>
      <p>请检查浏览器是否拦截弹窗</p>
      <p>付款完成前请不要关闭此窗口</p>
      <p>完成付款后请根据您的情况点击下面的按钮</p>
    </a-modal>
  </div>
</template>
<script>
import { queryAncillaryDetail } from '@/apis/ancillary'
import { fetchSelectPay } from '@/apis/extra'
import '@/components/l8-icon'
import PayBox from '@/components/pay-box'
import queryString from 'query-string'
import moment from 'moment'
import { userTypeMap } from '@/dicts/member'
import { get } from 'lodash'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

export default {
  components: {
    PayBox
  },
  data () {
    return {
      selectWay: {
        group: 0,
        index: 0
      },
      visible: false,
      orderId: '',
      orderNo: '',
      loginId: '',
      userId: '',
      totalAmount: '',
      orderDetail: {},
      orderType: 'TICKET',
      hideSuccess: false,
      payFilter: [],
      payLimit: undefined
    }
  },
  provide () {
    return {
      getOrderId: () => this.orderDetail.orderId
    }
  },
  created () {
    const query = queryString.parse(location.search)
    const userInfo = mainSettings.user?.get()

    if (query.orderNo) {
      this.orderNo = query.orderNo
    }
    if (userInfo) {
      this.loginId = userInfo.loginName
      if (userTypeMap[userInfo.userType] === 'CARRIER') {
        this.userId = query.outUserId
      }
    }
    if (query.detail) {
      this.hideSuccess = true
    }
    this.fetch()
    // this.fetchPay()
    this.getCmsData()
  },
  methods: {
    async getCmsData () {
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      // 设置单独辅营支付方式
      this.payFilter = get(pageCmsData, 'config.payMethodFilterConfig') ?? [{ bankId: 'alipYE' }]
    },
    selectPayWay (group, index) {
      this.selectWay = {
        group: group,
        index: index
      }
    },
    toDetail () {
      const query = {
        orderNo: this.orderNo
      }
      if (this.userId) {
        query.outUserId = this.userId
      }
      this.$router.push({
        path: '/ancillary/detail',
        query
      })
    },
    toPay () {
      this.$refs['payBox'].doPay({
        orderId: this.orderDetail.orderId || '',
        orderNo: this.orderNo,
        amount: this.orderDetail.unPayAmount,
        orderType: 'EXTRA',
        returnUrl: '/micro/main/ancillary/detail',
        extraCommonParam: `orderNo:${this.orderNo}`
      })
    },
    async fetch () {
      const { orderNo } = this
      try {
        const params = {
          alineCode: mainSettings.airline,
          orderNo: orderNo
        }
        const result = await queryAncillaryDetail(params)
        this.orderDetail = result
        this.orderId = result.orderId
        this.payLimit = result.orderDuration

        if (this.payLimit > 0) {
          const interval = setInterval(() => {
            const d = this.payLimit - 1000

            if (d < 0) {
              clearInterval(interval)
            }

            this.payLimit = d > 0 ? d : 0
          }, 1000)
        }

        if (result.status === 'PF' && Number(result.orderAmount) === 0) {
          this.toDetail()
        }
      } catch (e) {
        this.$message.error(e.message || '网络异常，请稍后再试！')
      }
    },
    async fetchPay () {
      const { orderNo, loginId } = this
      try {
        const params = {
          loginId: loginId,
          orderNo: orderNo
        }

        const result = await fetchSelectPay(params)
        this.payFilter = result.bankInfos
      } catch (e) {
        this.$message.error(e.message || '网络异常，请稍后再试！')
      }
    },
    handleError () {
      this.visible = false
    },
    handleOk () {
      this.visible = false
      this.toDetail()
    },
    payingHandler () {
    },
    payDoneHandler (bank, status) {
      if (status === 'SUCCESS') {
        this.payNoticeVisible = true
      }
      this.payLoading = false
    }
  },
  filters: {
    payLimit (value) {
      value = parseInt(value)
      if (isNaN(value)) {
        return ''
      }

      if (value <= 0) {
        return '0分钟'
      }

      const duration = moment.duration(value)
      const m = duration.minutes()
      const s = duration.seconds()

      return `${m}分${s}秒`
    }
  }
}
</script>

<style lang="less">
.mod-order-pay {
  .head {
    margin-top: 50px;
    color: #808080;
    border-bottom: solid 1px #c0c0c0;
    line-height: 40px;
    .order-num {
      color: @primary-color;
    }

    .l8-icon {
      color: @primary-color;
      margin-right: 10px;
    }

    .price {
      margin: 0 40px;
    }
  }

  .detail {
    border-bottom: solid 1px #d0d0d0;
    margin-bottom: 30px;
    table {
      text-align: center;
      width: 100%;
    }

    .title {
      margin-top: 30px;
      line-height: 25px;
      font-weight: bold;
    }

    em {
      color: @primary-color;
      font-style: normal;
      font-weight: bold;
    }

  }

  .total {
    float: right;
  }

  em {
    color: @primary-color;
    font-style: normal;
    font-weight: bold;
  }

  .tips {
    font-size: 14px;
    width: 650px;
    margin-top: 14px;
  }

  .tab {
    margin-top: 20px;
    overflow: hidden;
  }

  .foot {
    float: right;
    margin-top: 60px;
    padding-bottom: 200px;

    .btn {
      margin-left: 40px;
      width: 102px;
      height: 50px;
    }
  }

  .f-26 {
    font-size: 26px;
  }

  .f-22 {
    font-size: 22px;
  }

  .f-18 {
    font-size: 18px;
  }

  .f-16 {
    font-size: 16px;
  }

  .f-left {
    float: left;
  }

  .m-t-50 {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 768px) {
  .mod-order-pay {
    padding: 10px;
    .head {
      line-height: normal;
      padding-bottom: 10px;
      .order-num {
        float: left;
      }

      .price {
        margin: 0 10px;
      }
    }

    .tab {
      & > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
        padding: 0 25px 25px 0;
      }
      & > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
        min-width: 0;
      }

      .way {
        display: inline-block;
        min-width: 120px;
        margin-right: 0;
        margin-left: 30px;
      }
    }

    .tips {
      width: 80%;
    }

    .f-26 {
      font-size: 20px;
    }
  }
}
</style>
